import {
  AUDIT_POLICY_NAME,
  BLOCKING_POLICY_NAME,
  PR_COMMENTS_POLICY_NAME,
} from "@pages/ruleBoard/constants";

export const formatPolicyName = (name: string): string => {
  if (name === BLOCKING_POLICY_NAME) {
    return "Rule Column: Block";
  }
  if (name === PR_COMMENTS_POLICY_NAME) {
    return "Rule Column: Comment";
  }
  if (name === AUDIT_POLICY_NAME) {
    return "Rule Column: Monitor";
  }
  return `Policy: ${name}`;
};
